/**
 * @file 落地页入口文件
 * @note no-vue, just zepto.
 */
import '@/assets/styles/reboot.styl'
import '@/assets/styles/landing-page.styl'
import {
  FreyaMicroFrontendFramework,
  Login,
  URL,
} from '@/utils'
import initLiteRouter from '@/router/router-standard'
import retentionLibs from '@/assets/external-libs/retention-popup'
import Channel from '@/utils/channel-lib'
import RegisterPage, {
  $framework,
} from '@/views/register-page'
import { httpActivityInfo } from '@/views/register-page/http'
import MaintenancePagePC from '@/views/maintenance/pc-block'
import { renderMaintenancePage } from '@/utils/action-lib'

import raven from '@didi/raven'
import ravenPerformancePlugin from '@didi/raven/dist/plugins/performance'
raven.use(ravenPerformancePlugin)
import { isWebMarketing } from '@/utils/dom'
import $ from 'zepto'
import MainLoading from '@/components/main-loading'
import { getStore } from './store/store-standard'

$.ajaxSettings.beforeSend = (
  xhr: any,
  options: {
    url: string
    data: string
    headers?: Record<string, string>
  }
) => {
  // 如果是相对路径，则需要判断是否是sim环境，
  if (!options.url.startsWith('http')) {
    // 如果是sim环境，则修改网关前缀
    if (window.__INIT_STATE__.env === 'sim') {
      options.url = '/freya-gateway/freya' + options.url
    } else {
      // 否则，使用编译时的前缀
      options.url =
        process.env.VUE_APP_API_GATEWAY + options.url
    }
  }
  xhr.ravenDone = raven.trackRequest(
    options.url,
    options.data
  )
  const params = $.param({
    productId: '1001',
    fundsChannelId: '8001',
    resource: window.__INIT_STATE__.resource,
    adPosition: URL.get('adPosition'),
    tui: URL.get('tui'),
  })
  options.data = options.data || ''
  options.data = `${params}&${options.data}`

  const user = getStore('user')
  options.headers = {
    ...(options.headers || {}),
    'didi-fintech-header-content': JSON.stringify({
      token: user?.ticket || '',
      fintech_token: '',
    }),
  }
}
$.ajaxSettings.complete = (xhr: any) => {
  try {
    const data = JSON.parse(xhr.responseText)
    xhr.ravenDone(data.traceId, data)
  } catch (e) {
    xhr.ravenDone(+new Date(), xhr.responseText)
    console.log('[Not important]', e)
  }
}

/**
 * 人拉人拦截逻辑，如活动结束等
 * @returns true => 继续，其他值 => 中断，展示维护页
 */
const subJudgeMgm = async () => {
  const { errno } = await httpActivityInfo()
  // 活动有效或非MGM渠道
  if (errno === 0 || errno === -1) {
    return true
  }
  if (
    errno === 4908 /* 活动不在有效期 */ ||
    errno === 4905 /* 活动强制结束 */ ||
    errno === 4909 /* 没有复合条件的活动 */
  ) {
    return renderMaintenancePage('mgm_overdue')
  }
  // mgm渠道，但是返回了其他未捕获错误
  return renderMaintenancePage()
}

// 登录态校验
async function checkLoginStatus(ticket?: string) {
  // 不是web-marketing页面不执行
  if (!isWebMarketing()) {
    // 常规流程
    return 'normal'
  }
  MainLoading.show()
  try {
    // 初始化配置
    Login.init()
    // 设置ticket
    Login.setTicket(ticket)
    await RegisterPage.methods.onLoginImmediately.call(
      RegisterPage
    )
    Channel.dispatch('preload_page_receive_login_success')
    // 跳过
    return 'skip'
  } catch (error) {
    MainLoading.hide()
    // 到登录
    return 'login'
  }
}

/**
 * 入口函数
 */
const main = async () => {
  // pc拦截
  const ua = navigator.userAgent.toLocaleLowerCase()
  if (!ua.includes('iphone') && !ua.includes('android')) {
    return $('#root').html(MaintenancePagePC.template())
  }

  const { switcher } = window.__INIT_STATE__

  // 1. 渠道关闭
  if (switcher.disabled) {
    return renderMaintenancePage()
  }

  // 2. 是否命中人拉人拦截逻辑
  if ((await subJudgeMgm()) !== true) {
    return
  }

  // 挽留弹窗
  new FreyaMicroFrontendFramework(retentionLibs).run()

  /**
   * 3. iframe 方式加载
   */
  if (Channel.isUseFrame) {
    // 提前加载vue全家桶
    $framework.run(() =>
      Channel.dispatch('preload_page_onload_success')
    )
    Channel.subscribe(
      'marketing_page_login_success',
      (data: any) =>
        checkLoginStatus(data?.data?.ticket).then(
          (checkStatus) => {
            if (checkStatus !== 'skip') {
              Channel.abort({
                errorType: 'access_denied',
                errorMsg: `double_check_fail_${checkStatus}`,
              })
            }
          }
        )
    )
    return
  }

  // 4. 同步登录方式
  const checkStatus = await checkLoginStatus()

  if (checkStatus === 'skip') {
    // 跳过
    return
  }
  if (checkStatus === 'login') {
    // 到直接到登录
    location.hash = '#/register'
  }

  // 5. 常规：初始化页面及路由
  initLiteRouter(switcher.skipLanding)
}

main()
